export enum AuditLogEvent {
  None,
  View,
  ReportPdfExport,
  ReportXlsxExport,
  Add,
  Update,
  Delete,
  Create,
  Submit,
  Accept,
  Reject,
  Override,
  Login,
  Logout,
  Print,
  Migration,
  SearchFormExport
}
